import { t } from 'i18next';

export const checkRequired = (
  value,
  translationKey = 'stageConfig.required'
) => {
  if (!value || (typeof value === 'string' && !value.trim())) {
    return t(translationKey);
  }
};

export const removeUndefined = (obj) =>
  Object.keys(obj)
    .filter((key) => obj[key] !== undefined)
    .reduce((res, key) => {
      res[key] = obj[key];
      return res;
    }, {});
